import React from "react";
import { Outlet, Navigate } from "react-router-dom";

function PrivateRoutes() {
  return localStorage.getItem("auth_token") ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoutes;
